import { Button } from "@mui/material";
import React from "react";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useDispatch } from "react-redux";
import { imageEditorActions } from "../../../store/imageEditor";

export default function ResetMaskButton() {
  const dispatch = useDispatch();

  const handleResetMask = () => {
    dispatch(imageEditorActions.setMask(null));
  };

  return (
    <Button
      onClick={handleResetMask}
      startIcon={<RestartAltIcon />}
      variant="outlined"
    >
      Reset Mask
    </Button>
  );
}
